import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import api from "@/lib/api";
import { ArrowLeft } from "lucide-react";

export default function NewsDetailPage() {
  const { id } = useParams();
  const [n, setN] = useState(null);
  useEffect(() => { api.get(`/news/${id}`).then((r) => setN(r.data)).catch(() => setN(false)); }, [id]);
  if (n === null) return <div className="p-20 text-center">Loading…</div>;
  if (n === false) return <div className="p-20 text-center">Article not found. <Link to="/news" className="text-jpa-primary underline">Back</Link></div>;

  const ytId = n.video_url?.match(/(?:v=|youtu\.be\/|embed\/)([\w-]{11})/)?.[1];

  return (
    <article data-testid={`news-detail-${id}`} className="max-w-3xl mx-auto px-4 md:px-8 py-14">
      <Link to="/news" className="inline-flex items-center gap-2 text-sm uppercase tracking-widest text-jpa-primary mb-6">
        <ArrowLeft className="w-4 h-4" /> All news
      </Link>
      <div className="text-xs font-bold uppercase tracking-widest text-jpa-primary">{n.category} • {new Date(n.published_at).toLocaleDateString()}</div>
      <h1 className="font-display text-5xl md:text-6xl tracking-wider mt-3">{n.title}</h1>
      <div className="text-jpa-muted mt-3">By {n.author}</div>
      {n.media_type === "video" && ytId ? (
        <div className="aspect-video mt-8 border border-jpa-border">
          <iframe className="w-full h-full" src={`https://www.youtube.com/embed/${ytId}`} title={n.title} allowFullScreen />
        </div>
      ) : n.image_url ? (
        <img src={n.image_url} alt="" className="w-full aspect-video object-cover mt-8 border border-jpa-border" />
      ) : null}
      <div className="mt-8 text-lg leading-relaxed text-jpa-ink whitespace-pre-line">{n.body}</div>
    </article>
  );
}
